import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Router} from "react-router-dom";
import MainRouter from "./components/MainRouter";
import {Provider} from 'react-redux';
import store from './store';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import PDFViewer from './components/shared/utils/PDFViewer';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import * as Colors from 'material-ui/styles/colors';
import 'bootstrap-css-only/css/bootstrap.min.css';
import config from './config';
import {createBrowserHistory} from 'history';
import * as ReactGA from 'react-ga';
import register from "./registerServiceWorker";

const history = createBrowserHistory();
history.listen((location, action) => {
    ReactGA.set({page: location.pathname});
    ReactGA.pageview(location.pathname);
});

ReactGA.initialize('UA-79163224-1', {debug: true});
ReactGA.pageview(window.location.pathname + window.location.search);

const getTheme = () => {
    let overwrites = {
        "palette": {
            "primary1Color": Colors.indigo500,
            "primary2Color": Colors.blue700,
            "accent1Color": Colors.green500,
            "pickerHeaderColor": Colors.teal500
        }
    };
    return getMuiTheme(baseTheme, overwrites);
};

ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider muiTheme={getTheme()}>
            <div>
                <Router history={history} basename={config.router_basename}>
                    <MainRouter/>
                </Router>
                <PDFViewer/>
            </div>
        </MuiThemeProvider>
    </Provider>,

    document.getElementById('root')
);

register();



// WEBPACK FOOTER //
// ./src/index.js